import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

//styles
import './style.scss';

//antd component
import { Button } from 'antd';

//assets
import CustomIcons from 'components/CustomIcons';

function FinalControlScreen({
  continueAction,
  loading,
  title,
  content,
  children,
  className,
}) {
  const childClassName = classNames('control-final-screen', className);

  return (
    <div className={childClassName}>
      <div className="control-final-screen__icon">
        <CustomIcons type="present-finish" />
      </div>
      <div className="control-final-screen__content">
        {title && <h3 className="content-title">{title}</h3>}

        {(content || children) && (
          <div
            className="content-text"
            dangerouslySetInnerHTML={{ __html: content || children }}
          />
        )}
      </div>

      {continueAction !== undefined && (
        <Button loading={loading} onClick={continueAction} className="control-final-screen__btn">
          Continuer
        </Button>
      )}
    </div>
  );
}

FinalControlScreen.defaultProps = {
  loading: false,
  title: `Contrôle des présences effectué`,
  content: `Les parents d’élèves absents ainsi que l’administration ont été notifiés.`,
};

FinalControlScreen.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
  continueAction: PropTypes.func,
};

export default memo(FinalControlScreen);
